/* WN-HEADER-OVERLAY — header transparente sobre el hero, solo homepage.
   IntersectionObserver sobre .wn-hero: al perder intersección (el usuario ya
   bajó del hero) agrega .wn-header--scrolled al .section-header, que revierte
   el CSS (wn-header-overlay.css) al header sólido normal de Dawn.

   ResizeObserver sobre .announcement-bar: escribe su altura real en
   --wn-announcement-height para que el header fusionado (position:absolute)
   arranque justo debajo, nunca tapándolo. La altura no es fija — cambia con
   el breakpoint, con la "Escala de encabezado" del admin y con el wrap de
   texto cuando el carrusel de anuncios rota a un mensaje más largo — por
   eso se mide en vivo en vez de hardcodear un valor en CSS. ResizeObserver
   ya dispara solo con esos cambios de altura reales (incluida la rotación
   del carrusel, que sí cambia la altura cuando el texto envuelve distinto),
   no hace falta escuchar el evento de cambio de slide aparte. */
(function () {
  'use strict';

  function init() {
    if (window.Shopify && window.Shopify.designMode) return;

    var hero = document.querySelector('.wn-hero');
    var header = document.querySelector('.section-header');
    if (!hero || !header) return;

    var headerHeight = header.offsetHeight || 80;

    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        header.classList.toggle('wn-header--scrolled', !entry.isIntersecting);
      },
      { rootMargin: '-' + headerHeight + 'px 0px 0px 0px' }
    );
    observer.observe(hero);

    var announcementBar = document.querySelector('.announcement-bar');
    if (announcementBar && window.ResizeObserver) {
      var root = document.documentElement;
      var announcementObserver = new ResizeObserver(function (entries) {
        root.style.setProperty('--wn-announcement-height', entries[0].contentRect.height + 'px');
      });
      announcementObserver.observe(announcementBar);
    }
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  }
}());
